// extracted by mini-css-extract-plugin
export var label = "_4n-1";
export var reminder = "_4n-0";